// extracted by mini-css-extract-plugin
export default {"creditbtn":"upi_creditbtn__k9wrw","upiinp":"upi_upiinp__GqYM-"};